module.exports = __webpack_public_path__ + "img/index-banner-wap.cdfbd74a.jpg";